import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { customerPointSettingQueries } from '@/services/pointConfiguration/pointConfiguration.queries';

export const useCustomerPointSettingDetail = (programId: string, enabled: boolean) => {
  const { data, isLoading } = useQuery({
    ...customerPointSettingQueries.detail({ programId }),
    enabled,
  });
  return { pointSetting: data?.data, isLoading };
};
